import { useContext } from 'react';

const useProvidedContext = <T>(context: React.Context<T | null>): T => {
    const con = useContext(context);

    if (con) {
        return con;
    }

    throw new Error(`Context of type ${typeof (context)} was not provided`);
};

export default useProvidedContext;
